export const tokenRenewalTime = 5 * 60; // 5 minutes
